export default "__VITE_ASSET__66280671__"